import i18next from "i18next";
import Backend from "i18next-xhr-backend";
import { initReactI18next } from "react-i18next";
import { getLanguages } from "../models/settings";

export const configureI18n = () => {
  const { languages, default: defaultLanguage } = getLanguages();
  const savedLanguage = localStorage.getItem("app_language");
  // load translation using xhr -> see /public/locales
  // learn more: https://github.com/i18next/i18next-xhr-backend
  i18next
    .use(Backend)
    // pass the i18n instance to react-i18next.
    .use(initReactI18next)
    // init i18next
    // for all options read: https://www.i18next.com/overview/configuration-options
    .init({
      load: "currentOnly",
      fallbackLng: "en",
      lng: savedLanguage || defaultLanguage,
      supportedLngs: languages,
      defaultNS: "common",
      debug: false,
      ns: ["common"],
      interpolation: {
        escapeValue: false, // not needed for react as it escapes by default
      },
      backend: {
        loadPath: (lng: string[], ns: string[]) => {
          const [fileName] = ns;
          return `/i18n/${lng}/${fileName}.json?v=${
            import.meta.env.VITE_BUILD
          }`;
        },
        crossDomain: true,
      },
      react: {
        useSuspense: false,
      },
    });
};
